import { render, staticRenderFns } from "./login.vue?vue&type=template&id=cfa0f920&scoped=true&"
import script from "./login.vue?vue&type=script&setup=true&lang=js&"
export * from "./login.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=cfa0f920&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa0f920",
  null
  
)

export default component.exports